// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-title {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  color: #334155;
}

.status-title-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #f1f5f9;
  background-color: #ffffff;
  padding: 2px 8px;
  font-size: 0.688rem;
  font-weight: 700;
  color: #475569;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  white-space: nowrap;
}

.board-container {
  align-items: center;
  padding: 0px 4px;
  width: 100%;
}

@media (max-width: 600px) {
  .board-container {
    height: calc(100vh - 3.2rem);
    margin-top: 3.2rem;
  }
}

.board-header-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  z-index: 1300;
  flex-direction: column;
  border-radius: 8px;
}

.board-header-fixed {
  /* position: sticky;
  top: 0; */
  background-color: #ffffff;
  z-index: 1300;
  padding: 10px;
}

@media (max-width: 600px) {
  .board-header-container {
    flex-direction: column;
    align-items: flex-start;
    z-index: 1202;
  }
}

.board-items-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  height: 100%;
  width: 100%;
  gap: 0.5rem;
  overflow: auto;
  margin-bottom: 1rem;
  height: calc(100vh - 245px);
}

.board-items-container.fiveGrid {
  grid-template-columns: repeat(5, 1fr);
}

@media (max-width: 900px) {
  .board-items-container {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 600px) {
  .board-items-container {
    grid-template-columns: repeat(1, 1fr);
  }
}

.board-slots-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 0;
  width: calc(100vw - calc(85px + 2rem));
  overflow-x: scroll;
  overflow-y: hidden;
  width: 100%;
}

@media (max-width: 600px) {
  .board-slots-container {
    width: calc(100vw - 2rem);
  }
}

.board-slots-container::-webkit-scrollbar {
  display: none;
  scrollbar-width: none;
}

.no-slot-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

.no-slot {
  font-size: 0.875rem;
  font-weight: 600;
  color: red;
}

.notification-count {
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: var(--blue);
  color: white;
  font-size: 0.75rem;
  font-weight: 500;
  padding: 4px;
  border-radius: 50%;
  width: 22px;
  display: flex;
  height: 22px;
  align-items: center;
  justify-content: center;
  border: 1px solid #c1c1c1;
}

.selected-notification {
  background-color: white;
  color: var(--blue);
  border: 1px solid var(--blue);
}

.slot-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0.5rem 0.4rem 0.5rem;
  border-radius: 4px;
  border: 1px solid var(--blue-b0);
  cursor: pointer;
  transition: 0.2s;
  width: 100%;
  color: var(--blue-b0);
}

.selected-slot {
  background-color: var(--blue-b0);
  color: white;
}

.slot-time {
  font-size: 0.875rem;
  font-weight: 600;
  width: max-content;
}

.board-loader {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}

.ods-board-item-box {
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background-color: #ffffff;
  position: relative;
  transition: all 0.2s ease;
  padding: 12px 10px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.ods-board-item-box:hover {
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -2px rgba(0, 0, 0, 0.1);
}

/* ── Dark theme ── */
.dark .status-title {
  color: #94a3b8;
}

.dark .status-title-number {
  background-color: #1e293b;
  border-color: #334155;
  color: #cbd5e1;
}

.dark .board-header-fixed {
  background-color: #0f172a;
}

.dark .ods-board-item-box {
  background-color: #1e293b;
  border-color: #334155;
  color: #f1f5f9;
}

.dark .ods-board-item-title {
  color: #e2e8f0;
}

.dark .board-loader {
  background: rgba(15, 23, 42, 0.7);
}

.dark .board-header-title {
  color: #f1f5f9 !important;
}

.dark .disabled-arrow {
  background-color: #1e293b;
}

.dark .skeleton-board-item {
  background: linear-gradient(90deg, #1e293b 25%, #334155 50%, #1e293b 75%);
  background-size: 200% 100%;
}

.dark .skeleton-order-item {
  background: linear-gradient(90deg, #1e293b 25%, #334155 50%, #1e293b 75%);
  background-size: 200% 100%;
}

.dark .skeleton-single-item {
  background: linear-gradient(90deg, #1e293b 25%, #334155 50%, #1e293b 75%);
  background-size: 200% 100%;
}

.dark .pagination-total-results {
  color: #64748b;
}

.ods-board-item-cancel-btn {
  position: absolute;
  top: -8px;
  right: -8px;
  z-index: 5;
}

.ods-board-item-title {
  display: flex;
  justify-content: space-between;
  font-size: 0.813rem;
  font-weight: 700;
  color: #344767;
  flex-wrap: wrap;
  margin-bottom: 4px;
}

.ods-board-item-footer {
  font-size: 0.8rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ods-board-item-status {
  display: flex;
  align-items: center;
  border-radius: 8px;
  padding: 0 0.5rem;
  background-color: #fcffcb;
  color: #838a00;
  border: 1px solid;
  font-size: 0.813rem;
  font-weight: 500;
  width: max-content;
  margin-top: 0.2rem;
}

.ods-board-item-status-expired {
  background-color: #ffcccc;
  color: #cc0000;
}

.ods-board-item-count {
  display: flex;
  align-items: center;
  gap: 0.2rem;
  border-radius: 10px;
  padding: 0 0.5rem;
  background-color: #d3e2ff;
  color: var(--blue);
  font-weight: 600;
}

.skeleton-loader {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  gap: 1rem;
  flex: 1;
}

.board-header-title {
  font-weight: 700 !important;
  line-height: 1 !important;
  color: #333 !important;
  font-size: 1.5rem;
}

.pagination-text {
  display: flex;
  gap: 5px;
}
.pagination-current-page {
  font-weight: 600;
}

.pagination-total-results {
  color: #979797;
}

.pagination-container {
  display: flex;
  border: 1.5px solid #7474743d;
  font-size: 0.875rem;
  border-radius: 4px;
  box-shadow:
    rgba(0, 0, 0, 0.1) 0px 10px 15px -22px,
    rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
}

.pagination-container > div {
  border-right: 1.5px solid #7474743d;
  display: flex;
  align-items: center;
  padding: 0.2rem 0.5rem;
}

.pagination-container > div:last-child {
  border-right: none;
}

.pagination-arrow {
  cursor: pointer;
  color: grey;
}

.disabled-arrow {
  pointer-events: none;
  cursor: not-allowed;
  background-color: #eeeeee;
}

.skeleton-board-item {
  width: 100%;
  height: 6rem;
  background: linear-gradient(90deg, #f0f0f0 25%, #f8f8f8 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite linear;
  border-radius: 10px;
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.skeleton-order-item {
  width: 100%;
  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #f8f8f8 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite linear;
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.skeleton-single-item {
  width: 100%;
  height: 40px;
  background: linear-gradient(90deg, #e1e1e1 25%, #f8f8f8 50%, #e1e1e1 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite linear;
  border-radius: 10px;
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.skeleton-calender-container {
  padding: 1.5rem;
  gap: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media (max-width: 600px) {
  .skeleton-calender-container {
    padding: 1rem;
    gap: 1rem;
  }
}

.skeleton-calendar {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1rem;
}

@media (max-width: 600px) {
  .skeleton-calendar {
    grid-template-columns: repeat(7, 1fr);
    gap: 5px;
  }
}

/* .board-item-0::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 0.3rem;
  background-color: #6b88ff;
} */

/* .board-item-1::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 0.3rem;
  background-color: #ffd166;
} */

/* .board-item-2::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 0.3rem;
  background-color: #ff6b6b;
} */

/* .board-item-3::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 0.3rem;
  background-color: #6bff6b;
} */

.board-item-details-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.board-item-details-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

@media (max-width: 768px) {
  .board-item-details-content {
    flex-direction: column;
  }
}

.ods-board-item-box:hover .ods-board-item-show-details {
  display: block;
}

.ods-board-item-show-details {
  display: none;
}

.card__arrow {
  background: var(--blue);
  padding: 0.5rem;
  transition: 0.2s;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 3.5rem;
  border-top-left-radius: 10px;
  align-self: flex-end;
  margin-left: auto;
}

svg {
  transition: 0.2s;
}

.card__arrow:hover {
  background: #111;
}

.card__arrow:hover svg {
  transform: translateX(3px);
}

.board-item-details-left-box {
  flex: 1;
}

/* .board-items::-webkit-scrollbar {
  width: 5px;
} */

/* .board-items::-webkit-scrollbar-track {
  background: transparent;
} */

/* .board-items::-webkit-scrollbar-thumb {
  background-color: rgba(155, 155, 155, 0.7);
  border-radius: 20px;
  border: transparent;
} */

/* .board-items::-webkit-scrollbar-thumb:hover {
  background: #8d8d8d;
  cursor: pointer;
} */

.board-filter-menu-paper {
  padding: 1rem !important;
}

.board-filter-menu-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.soft-select__menu-portal {
  z-index: 10001 !important;
}

.board-filter-date-inputs {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.board-filter-date-inputs > div {
  width: 8rem !important;
}

.board-filter-apply-box {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
}

.board-item-details-delivery-slot {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.board-item-details-delivery-slot-date {
  color: grey;
}

.ods-board-item-order-id-box {
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

.board-status-data {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.board-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 0rem 0rem 0.6rem 0rem;
  border-radius: 10px;
}

.board-status-left-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
}

.board-status-left-container.fiveLeftGrid {
  grid-template-columns: repeat(5, 1fr);
}

@media (max-width: 600px) {
  .board-status-left-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}

.board-status-title {
  font-size: 1rem;
  font-weight: 700;
  color: #535862;
}

.board-status-count {
  font-size: 1rem;
  font-weight: 600;
}

.board-status-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.board-status-indicator {
  width: 0.2rem;
  height: 85%;
}

.indicator-blue {
  background-color: #6b88ff;
}

.indicator-yellow {
  background-color: #ffd166;
}

.indicator-red {
  background-color: #ff6b6b;
}

.indicator-green {
  background-color: #6bff6b;
}

.indicator-orange {
  background-color: #d4bd19;
}

.board-status-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

@media (max-width: 568px) {
  .board-status-box {
    flex-direction: column;
  }
}

.board-status-right-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

@media (max-width: 568px) {
  .board-status-right-container {
    justify-content: space-between;
    width: 100%;
  }
}

.day-contents {
  position: relative;
  text-align: center;
}

.indicator-dot {
  position: absolute;
  bottom: -3px;
  left: 50%;
  transform: translateX(-50%);
  width: 6px;
  height: 6px;
  background-color: #ff3030;
  border-radius: 50%;
}

.react-datepicker__day--outside-month {
  color: rgb(203, 203, 203);
  pointer-events: none;
}

.react-datepicker__day--outside-month .day-contents .indicator-dot {
  display: none;
}

.pause-modal-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.pause-modal-header {
  font-size: 1.2rem;
  font-weight: 600;
}

.pause-modal-subtitle {
  font-size: 0.8rem;
  color: #717171;
}

.status-outer-parent {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 10;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.6);
  background-color: rgba(255, 255, 255, 0.85);
  padding: 12px !important;
  backdrop-filter: blur(12px);
  margin-bottom: 0;
  border-left: none;
  border-right: none;
  border-top: none;
}

.status-icon-title-outer-parent {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-icon-title-outer-parent img {
  height: 1.25rem;
  object-fit: cover;
}

.board-item-details-left-info-1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  border-bottom: 1px solid #e6e6e6;
  padding: 0.5rem 0;
  color: #333 !important;
}

.odsLeftContainer {
  display: flex;
  align-items: center;
  gap: 8px;
}

.board-status-date-container {
  position: relative;
}

.board-status-date-container .soft-datepicker {
  border: 1px solid var(--surface-g1);
  border-radius: 4px;
  background-color: var(--surface-white);
  color: var(--surface-g4);
  padding: 10px 12px 10px 12px !important;
}

.board-status-date-container .react-datepicker__input-container {
  flex-direction: row-reverse;
}

.ods-board-item-number {
  font-size: -0.813rem;
  font-weight: 500;
  color: #798097;
}

/* Status Badge Styles */
.ods-board-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  padding: 5px 12px;
  border-radius: 16px;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.ods-board-status-badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

.status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* Time Difference Styles */
.ods-board-state-diff {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  color: #666;
  margin-bottom: 8px;
  padding: 4px 8px;
  background-color: #f5f5f5;
  border-radius: 8px;
  font-weight: 500;
}

.ods-board-state-diff span {
  font-style: italic;
}

.ods-board-item-box:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.ods-platform-status-chips {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ods-platform-status-chip {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid;
}

.ods-platform-status-chip.enabled {
  background-color: #e8f5e9;
  border-color: #4caf50;
  color: #2e7d32;
}

.ods-platform-status-chip.disabled {
  background-color: #fff3e0;
  border-color: #ff9800;
  color: #e65100;
}

.ods-platform-status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

.ods-platform-status-chip.enabled .ods-platform-status-dot {
  background-color: #4caf50;
}

.ods-platform-status-chip.disabled .ods-platform-status-dot {
  background-color: #ff9800;
}

.ods-platform-status-label {
  font-weight: 600;
}

.ods-platform-status-text {
  font-weight: 400;
  opacity: 0.85;
}

.ods-platform-dropdown-button {
  position: relative;
}

.ods-platform-dropdown-container {
  position: absolute;
  z-index: 100;
  margin-top: 4px;
  background-color: white;
  border: 1px solid #eba85a;
  width: 100%;
  border-radius: 6px;
  padding: 8px;
}

.ods-platform-dropdown-action-buttons {
  display: flex;
  align-items: center;
  gap: 6px;
}

.ods_card_arrow_container {
  display: flex;
  align-items: center;
  margin-top: 4px;
}

.logistic-button-wrapper {
  background: var(--blue);
  transition: 0.2s;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-top-right-radius: 10px;
  color: var(--surface-white);
  padding: 3px 5px;
  font-size: 0.813rem;
}

.ods-label-print-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border: 1.5px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  color: #374151;
  cursor: pointer;
  transition:
    background 0.15s,
    border-color 0.15s;
  flex-shrink: 0;
  padding: 0;
}

.ods-label-print-btn:hover:not(:disabled) {
  background: #f3f4f6;
  border-color: #9ca3af;
}

.ods-label-print-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.slot-upper-container {
  display: flex;
  align-items: center;
  gap: 12px;
}

.ods-platform-modal-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 200px;
  overflow-y: auto;
  padding-right: 4px;
}

.ods-platform-modal-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #949494;
  padding: 8px 10px;
  border-radius: 6px;
}

.ods-platform-modal-list::-webkit-scrollbar {
  width: 6px;
}

.ods-platform-modal-list::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
}

.ods-platform-status-right {
  font-size: 0.8rem;
  font-weight: 600;
  color: #555;
}

.ods-status-chip {
  font-size: 0.75rem;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 16px;
  border: 1px solid;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 70px;
}

/* Active = Green */
.ods-status-chip.active {
  background-color: #4caf50;
  color: var(--surface-white);
  border-color: #4caf50;
}

/* Inactive = Red */
.ods-status-chip.inactive {
  background-color: #f44336;
  color: var(--surface-white);
  border-color: #f44336;
}

.future-orders-dot {
  position: absolute;
  top: -3px;
  right: -2px;
  width: 12px;
  height: 13px;
  border-radius: 50%;
  background-color: #e63946;
  animation: blink-dot 1.2s ease-in-out infinite;
  z-index: 10;
  pointer-events: none;
}

.ods-board-bell {
  background-color: var(--surface-white);
  border-radius: 50%;
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ods-board-bell:hover {
  background-color: #ffddf2;
  border-radius: 50%;
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ods-board-bell:active {
  background-color: #eaecef;
}

@keyframes blink-dot {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}

.ods-status-legend {
  height: 10px;
  width: 10px;
  border-radius: 50%;
}

/* Lane column containers to match the provided markup */
.board-items {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 0;
  border-radius: 12px !important;
  border: 1px solid #e2e8f0;
  background-color: rgba(241, 245, 249, 0.45) !important;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;
  box-sizing: border-box;
}

/* Outer draggable wrapper customizations for layout and preventing shadow clipping */
.board-item-0,
.board-item-1,
.board-item-2,
.board-item-3,
.board-item-4 {
  background-color: transparent !important;
  border-radius: 8px !important;
  overflow: visible !important;
  margin: 10px 10px 0 10px !important;
}

.board-item-0:last-child,
.board-item-1:last-child,
.board-item-2:last-child,
.board-item-3:last-child,
.board-item-4:last-child {
  margin-bottom: 10px !important;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/delivery/delivery.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE;IACE,4BAA4B;IAC5B,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE;WACS;EACT,yBAAyB;EACzB,aAAa;EACb,aAAa;AACf;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,WAAW;EACX,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE;;qCAEmC;AACrC;;AAEA,qBAAqB;AACrB;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yEAAyE;EACzE,0BAA0B;AAC5B;;AAEA;EACE,yEAAyE;EACzE,0BAA0B;AAC5B;;AAEA;EACE,yEAAyE;EACzE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,SAAS;EACT,OAAO;AACT;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB;;wCAEsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yEAAyE;EACzE,0BAA0B;EAC1B,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yEAAyE;EACzE,0BAA0B;EAC1B,gDAAgD;AAClD;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yEAAyE;EACzE,0BAA0B;EAC1B,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;IACb,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;IACrC,QAAQ;EACV;AACF;;AAEA;;;;;;;;GAQG;;AAEH;;;;;;;;GAQG;;AAEH;;;;;;;;GAQG;;AAEH;;;;;;;;GAQG;;AAEH;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,4BAA4B;EAC5B,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,OAAO;AACT;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;;;;GAIG;;AAEH;;;GAGG;;AAEH;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,8BAA8B;EAChC;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE;IACE,8BAA8B;IAC9B,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,4BAA4B;EAC5B,6BAA6B;EAC7B,iDAAiD;EACjD,2CAA2C;EAC3C,wBAAwB;EACxB,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,sCAAsC;EACtC,wBAAwB;EACxB,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf;;sBAEoB;EACpB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,8CAA8C;EAC9C,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,8BAA8B;EAC9B,yBAAyB;EACzB,sDAAsD;EACtD,sDAAsD;EACtD,sBAAsB;AACxB;;AAEA,qFAAqF;AACrF;;;;;EAKE,wCAAwC;EACxC,6BAA6B;EAC7B,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;;;;;EAKE,8BAA8B;AAChC","sourcesContent":[".status-title {\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  color: #334155;\n}\n\n.status-title-number {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 24px;\n  border-radius: 50%;\n  border: 1px solid #f1f5f9;\n  background-color: #ffffff;\n  padding: 2px 8px;\n  font-size: 0.688rem;\n  font-weight: 700;\n  color: #475569;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  white-space: nowrap;\n}\n\n.board-container {\n  align-items: center;\n  padding: 0px 4px;\n  width: 100%;\n}\n\n@media (max-width: 600px) {\n  .board-container {\n    height: calc(100vh - 3.2rem);\n    margin-top: 3.2rem;\n  }\n}\n\n.board-header-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  width: 100%;\n  z-index: 1300;\n  flex-direction: column;\n  border-radius: 8px;\n}\n\n.board-header-fixed {\n  /* position: sticky;\n  top: 0; */\n  background-color: #ffffff;\n  z-index: 1300;\n  padding: 10px;\n}\n\n@media (max-width: 600px) {\n  .board-header-container {\n    flex-direction: column;\n    align-items: flex-start;\n    z-index: 1202;\n  }\n}\n\n.board-items-container {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  height: 100%;\n  width: 100%;\n  gap: 0.5rem;\n  overflow: auto;\n  margin-bottom: 1rem;\n  height: calc(100vh - 245px);\n}\n\n.board-items-container.fiveGrid {\n  grid-template-columns: repeat(5, 1fr);\n}\n\n@media (max-width: 900px) {\n  .board-items-container {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n@media (max-width: 600px) {\n  .board-items-container {\n    grid-template-columns: repeat(1, 1fr);\n  }\n}\n\n.board-slots-container {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.5rem 0;\n  width: calc(100vw - calc(85px + 2rem));\n  overflow-x: scroll;\n  overflow-y: hidden;\n  width: 100%;\n}\n\n@media (max-width: 600px) {\n  .board-slots-container {\n    width: calc(100vw - 2rem);\n  }\n}\n\n.board-slots-container::-webkit-scrollbar {\n  display: none;\n  scrollbar-width: none;\n}\n\n.no-slot-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.no-slot {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: red;\n}\n\n.notification-count {\n  position: absolute;\n  top: -8px;\n  right: -8px;\n  background-color: var(--blue);\n  color: white;\n  font-size: 0.75rem;\n  font-weight: 500;\n  padding: 4px;\n  border-radius: 50%;\n  width: 22px;\n  display: flex;\n  height: 22px;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #c1c1c1;\n}\n\n.selected-notification {\n  background-color: white;\n  color: var(--blue);\n  border: 1px solid var(--blue);\n}\n\n.slot-item {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.4rem 0.5rem 0.4rem 0.5rem;\n  border-radius: 4px;\n  border: 1px solid var(--blue-b0);\n  cursor: pointer;\n  transition: 0.2s;\n  width: 100%;\n  color: var(--blue-b0);\n}\n\n.selected-slot {\n  background-color: var(--blue-b0);\n  color: white;\n}\n\n.slot-time {\n  font-size: 0.875rem;\n  font-weight: 600;\n  width: max-content;\n}\n\n.board-loader {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: rgba(255, 255, 255, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  pointer-events: none;\n}\n\n.ods-board-item-box {\n  height: 100%;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  font-size: 1rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background-color: #ffffff;\n  position: relative;\n  transition: all 0.2s ease;\n  padding: 12px 10px;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.ods-board-item-box:hover {\n  box-shadow:\n    0 4px 6px -1px rgba(0, 0, 0, 0.1),\n    0 2px 4px -2px rgba(0, 0, 0, 0.1);\n}\n\n/* ── Dark theme ── */\n.dark .status-title {\n  color: #94a3b8;\n}\n\n.dark .status-title-number {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #cbd5e1;\n}\n\n.dark .board-header-fixed {\n  background-color: #0f172a;\n}\n\n.dark .ods-board-item-box {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #f1f5f9;\n}\n\n.dark .ods-board-item-title {\n  color: #e2e8f0;\n}\n\n.dark .board-loader {\n  background: rgba(15, 23, 42, 0.7);\n}\n\n.dark .board-header-title {\n  color: #f1f5f9 !important;\n}\n\n.dark .disabled-arrow {\n  background-color: #1e293b;\n}\n\n.dark .skeleton-board-item {\n  background: linear-gradient(90deg, #1e293b 25%, #334155 50%, #1e293b 75%);\n  background-size: 200% 100%;\n}\n\n.dark .skeleton-order-item {\n  background: linear-gradient(90deg, #1e293b 25%, #334155 50%, #1e293b 75%);\n  background-size: 200% 100%;\n}\n\n.dark .skeleton-single-item {\n  background: linear-gradient(90deg, #1e293b 25%, #334155 50%, #1e293b 75%);\n  background-size: 200% 100%;\n}\n\n.dark .pagination-total-results {\n  color: #64748b;\n}\n\n.ods-board-item-cancel-btn {\n  position: absolute;\n  top: -8px;\n  right: -8px;\n  z-index: 5;\n}\n\n.ods-board-item-title {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.813rem;\n  font-weight: 700;\n  color: #344767;\n  flex-wrap: wrap;\n  margin-bottom: 4px;\n}\n\n.ods-board-item-footer {\n  font-size: 0.8rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.ods-board-item-status {\n  display: flex;\n  align-items: center;\n  border-radius: 8px;\n  padding: 0 0.5rem;\n  background-color: #fcffcb;\n  color: #838a00;\n  border: 1px solid;\n  font-size: 0.813rem;\n  font-weight: 500;\n  width: max-content;\n  margin-top: 0.2rem;\n}\n\n.ods-board-item-status-expired {\n  background-color: #ffcccc;\n  color: #cc0000;\n}\n\n.ods-board-item-count {\n  display: flex;\n  align-items: center;\n  gap: 0.2rem;\n  border-radius: 10px;\n  padding: 0 0.5rem;\n  background-color: #d3e2ff;\n  color: var(--blue);\n  font-weight: 600;\n}\n\n.skeleton-loader {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  gap: 1rem;\n  flex: 1;\n}\n\n.board-header-title {\n  font-weight: 700 !important;\n  line-height: 1 !important;\n  color: #333 !important;\n  font-size: 1.5rem;\n}\n\n.pagination-text {\n  display: flex;\n  gap: 5px;\n}\n.pagination-current-page {\n  font-weight: 600;\n}\n\n.pagination-total-results {\n  color: #979797;\n}\n\n.pagination-container {\n  display: flex;\n  border: 1.5px solid #7474743d;\n  font-size: 0.875rem;\n  border-radius: 4px;\n  box-shadow:\n    rgba(0, 0, 0, 0.1) 0px 10px 15px -22px,\n    rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;\n}\n\n.pagination-container > div {\n  border-right: 1.5px solid #7474743d;\n  display: flex;\n  align-items: center;\n  padding: 0.2rem 0.5rem;\n}\n\n.pagination-container > div:last-child {\n  border-right: none;\n}\n\n.pagination-arrow {\n  cursor: pointer;\n  color: grey;\n}\n\n.disabled-arrow {\n  pointer-events: none;\n  cursor: not-allowed;\n  background-color: #eeeeee;\n}\n\n.skeleton-board-item {\n  width: 100%;\n  height: 6rem;\n  background: linear-gradient(90deg, #f0f0f0 25%, #f8f8f8 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite linear;\n  border-radius: 10px;\n}\n\n@keyframes skeleton-loading {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n.skeleton-order-item {\n  width: 100%;\n  height: 20px;\n  background: linear-gradient(90deg, #f0f0f0 25%, #f8f8f8 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite linear;\n}\n\n@keyframes skeleton-loading {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n.skeleton-single-item {\n  width: 100%;\n  height: 40px;\n  background: linear-gradient(90deg, #e1e1e1 25%, #f8f8f8 50%, #e1e1e1 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite linear;\n  border-radius: 10px;\n}\n\n@keyframes skeleton-loading {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n.skeleton-calender-container {\n  padding: 1.5rem;\n  gap: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n@media (max-width: 600px) {\n  .skeleton-calender-container {\n    padding: 1rem;\n    gap: 1rem;\n  }\n}\n\n.skeleton-calendar {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 1rem;\n}\n\n@media (max-width: 600px) {\n  .skeleton-calendar {\n    grid-template-columns: repeat(7, 1fr);\n    gap: 5px;\n  }\n}\n\n/* .board-item-0::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 0.3rem;\n  background-color: #6b88ff;\n} */\n\n/* .board-item-1::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 0.3rem;\n  background-color: #ffd166;\n} */\n\n/* .board-item-2::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 0.3rem;\n  background-color: #ff6b6b;\n} */\n\n/* .board-item-3::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 0.3rem;\n  background-color: #6bff6b;\n} */\n\n.board-item-details-title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.board-item-details-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n@media (max-width: 768px) {\n  .board-item-details-content {\n    flex-direction: column;\n  }\n}\n\n.ods-board-item-box:hover .ods-board-item-show-details {\n  display: block;\n}\n\n.ods-board-item-show-details {\n  display: none;\n}\n\n.card__arrow {\n  background: var(--blue);\n  padding: 0.5rem;\n  transition: 0.2s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  width: 3.5rem;\n  border-top-left-radius: 10px;\n  align-self: flex-end;\n  margin-left: auto;\n}\n\nsvg {\n  transition: 0.2s;\n}\n\n.card__arrow:hover {\n  background: #111;\n}\n\n.card__arrow:hover svg {\n  transform: translateX(3px);\n}\n\n.board-item-details-left-box {\n  flex: 1;\n}\n\n/* .board-items::-webkit-scrollbar {\n  width: 5px;\n} */\n\n/* .board-items::-webkit-scrollbar-track {\n  background: transparent;\n} */\n\n/* .board-items::-webkit-scrollbar-thumb {\n  background-color: rgba(155, 155, 155, 0.7);\n  border-radius: 20px;\n  border: transparent;\n} */\n\n/* .board-items::-webkit-scrollbar-thumb:hover {\n  background: #8d8d8d;\n  cursor: pointer;\n} */\n\n.board-filter-menu-paper {\n  padding: 1rem !important;\n}\n\n.board-filter-menu-container {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n.soft-select__menu-portal {\n  z-index: 10001 !important;\n}\n\n.board-filter-date-inputs {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.board-filter-date-inputs > div {\n  width: 8rem !important;\n}\n\n.board-filter-apply-box {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n}\n\n.board-item-details-delivery-slot {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.board-item-details-delivery-slot-date {\n  color: grey;\n}\n\n.ods-board-item-order-id-box {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n}\n\n.board-status-data {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.board-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin: 0rem 0rem 0.6rem 0rem;\n  border-radius: 10px;\n}\n\n.board-status-left-container {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem;\n}\n\n.board-status-left-container.fiveLeftGrid {\n  grid-template-columns: repeat(5, 1fr);\n}\n\n@media (max-width: 600px) {\n  .board-status-left-container {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n  }\n}\n\n.board-status-title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #535862;\n}\n\n.board-status-count {\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.board-status-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.board-status-indicator {\n  width: 0.2rem;\n  height: 85%;\n}\n\n.indicator-blue {\n  background-color: #6b88ff;\n}\n\n.indicator-yellow {\n  background-color: #ffd166;\n}\n\n.indicator-red {\n  background-color: #ff6b6b;\n}\n\n.indicator-green {\n  background-color: #6bff6b;\n}\n\n.indicator-orange {\n  background-color: #d4bd19;\n}\n\n.board-status-box {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n@media (max-width: 568px) {\n  .board-status-box {\n    flex-direction: column;\n  }\n}\n\n.board-status-right-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n@media (max-width: 568px) {\n  .board-status-right-container {\n    justify-content: space-between;\n    width: 100%;\n  }\n}\n\n.day-contents {\n  position: relative;\n  text-align: center;\n}\n\n.indicator-dot {\n  position: absolute;\n  bottom: -3px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 6px;\n  height: 6px;\n  background-color: #ff3030;\n  border-radius: 50%;\n}\n\n.react-datepicker__day--outside-month {\n  color: rgb(203, 203, 203);\n  pointer-events: none;\n}\n\n.react-datepicker__day--outside-month .day-contents .indicator-dot {\n  display: none;\n}\n\n.pause-modal-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.pause-modal-header {\n  font-size: 1.2rem;\n  font-weight: 600;\n}\n\n.pause-modal-subtitle {\n  font-size: 0.8rem;\n  color: #717171;\n}\n\n.status-outer-parent {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.6);\n  background-color: rgba(255, 255, 255, 0.85);\n  padding: 12px !important;\n  backdrop-filter: blur(12px);\n  margin-bottom: 0;\n  border-left: none;\n  border-right: none;\n  border-top: none;\n}\n\n.status-icon-title-outer-parent {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.status-icon-title-outer-parent img {\n  height: 1.25rem;\n  object-fit: cover;\n}\n\n.board-item-details-left-info-1 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  border-bottom: 1px solid #e6e6e6;\n  padding: 0.5rem 0;\n  color: #333 !important;\n}\n\n.odsLeftContainer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.board-status-date-container {\n  position: relative;\n}\n\n.board-status-date-container .soft-datepicker {\n  border: 1px solid var(--surface-g1);\n  border-radius: 4px;\n  background-color: var(--surface-white);\n  color: var(--surface-g4);\n  padding: 10px 12px 10px 12px !important;\n}\n\n.board-status-date-container .react-datepicker__input-container {\n  flex-direction: row-reverse;\n}\n\n.ods-board-item-number {\n  font-size: -0.813rem;\n  font-weight: 500;\n  color: #798097;\n}\n\n/* Status Badge Styles */\n.ods-board-status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 5px 12px;\n  border-radius: 16px;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  transition: all 0.2s ease;\n}\n\n.ods-board-status-badge:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n}\n\n.status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  animation: pulse 2s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n/* Time Difference Styles */\n.ods-board-state-diff {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 11px;\n  color: #666;\n  margin-bottom: 8px;\n  padding: 4px 8px;\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  font-weight: 500;\n}\n\n.ods-board-state-diff span {\n  font-style: italic;\n}\n\n.ods-board-item-box:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.ods-platform-status-chips {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ods-platform-status-chip {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 500;\n  border: 1px solid;\n}\n\n.ods-platform-status-chip.enabled {\n  background-color: #e8f5e9;\n  border-color: #4caf50;\n  color: #2e7d32;\n}\n\n.ods-platform-status-chip.disabled {\n  background-color: #fff3e0;\n  border-color: #ff9800;\n  color: #e65100;\n}\n\n.ods-platform-status-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.ods-platform-status-chip.enabled .ods-platform-status-dot {\n  background-color: #4caf50;\n}\n\n.ods-platform-status-chip.disabled .ods-platform-status-dot {\n  background-color: #ff9800;\n}\n\n.ods-platform-status-label {\n  font-weight: 600;\n}\n\n.ods-platform-status-text {\n  font-weight: 400;\n  opacity: 0.85;\n}\n\n.ods-platform-dropdown-button {\n  position: relative;\n}\n\n.ods-platform-dropdown-container {\n  position: absolute;\n  z-index: 100;\n  margin-top: 4px;\n  background-color: white;\n  border: 1px solid #eba85a;\n  width: 100%;\n  border-radius: 6px;\n  padding: 8px;\n}\n\n.ods-platform-dropdown-action-buttons {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.ods_card_arrow_container {\n  display: flex;\n  align-items: center;\n  margin-top: 4px;\n}\n\n.logistic-button-wrapper {\n  background: var(--blue);\n  transition: 0.2s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  border-top-right-radius: 10px;\n  color: var(--surface-white);\n  padding: 3px 5px;\n  font-size: 0.813rem;\n}\n\n.ods-label-print-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border: 1.5px solid #d1d5db;\n  border-radius: 6px;\n  background: #fff;\n  color: #374151;\n  cursor: pointer;\n  transition:\n    background 0.15s,\n    border-color 0.15s;\n  flex-shrink: 0;\n  padding: 0;\n}\n\n.ods-label-print-btn:hover:not(:disabled) {\n  background: #f3f4f6;\n  border-color: #9ca3af;\n}\n\n.ods-label-print-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.slot-upper-container {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.ods-platform-modal-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-height: 200px;\n  overflow-y: auto;\n  padding-right: 4px;\n}\n\n.ods-platform-modal-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid #949494;\n  padding: 8px 10px;\n  border-radius: 6px;\n}\n\n.ods-platform-modal-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.ods-platform-modal-list::-webkit-scrollbar-thumb {\n  background: #ccc;\n  border-radius: 10px;\n}\n\n.ods-platform-status-right {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #555;\n}\n\n.ods-status-chip {\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 4px 10px;\n  border-radius: 16px;\n  border: 1px solid;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 70px;\n}\n\n/* Active = Green */\n.ods-status-chip.active {\n  background-color: #4caf50;\n  color: var(--surface-white);\n  border-color: #4caf50;\n}\n\n/* Inactive = Red */\n.ods-status-chip.inactive {\n  background-color: #f44336;\n  color: var(--surface-white);\n  border-color: #f44336;\n}\n\n.future-orders-dot {\n  position: absolute;\n  top: -3px;\n  right: -2px;\n  width: 12px;\n  height: 13px;\n  border-radius: 50%;\n  background-color: #e63946;\n  animation: blink-dot 1.2s ease-in-out infinite;\n  z-index: 10;\n  pointer-events: none;\n}\n\n.ods-board-bell {\n  background-color: var(--surface-white);\n  border-radius: 50%;\n  height: 24px;\n  width: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ods-board-bell:hover {\n  background-color: #ffddf2;\n  border-radius: 50%;\n  height: 24px;\n  width: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ods-board-bell:active {\n  background-color: #eaecef;\n}\n\n@keyframes blink-dot {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n  }\n}\n\n.ods-status-legend {\n  height: 10px;\n  width: 10px;\n  border-radius: 50%;\n}\n\n/* Lane column containers to match the provided markup */\n.board-items {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-width: 0;\n  border-radius: 12px !important;\n  border: 1px solid #e2e8f0;\n  background-color: rgba(241, 245, 249, 0.45) !important;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;\n  box-sizing: border-box;\n}\n\n/* Outer draggable wrapper customizations for layout and preventing shadow clipping */\n.board-item-0,\n.board-item-1,\n.board-item-2,\n.board-item-3,\n.board-item-4 {\n  background-color: transparent !important;\n  border-radius: 8px !important;\n  overflow: visible !important;\n  margin: 10px 10px 0 10px !important;\n}\n\n.board-item-0:last-child,\n.board-item-1:last-child,\n.board-item-2:last-child,\n.board-item-3:last-child,\n.board-item-4:last-child {\n  margin-bottom: 10px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
